import { render } from "./TodoInput.vue?vue&type=template&id=0170c4cc&scoped=true"
import script from "./TodoInput.vue?vue&type=script&lang=js"
export * from "./TodoInput.vue?vue&type=script&lang=js"

import "./TodoInput.vue?vue&type=style&index=0&id=0170c4cc&scoped=true&lang=css"

import exportComponent from "/home/bammer/vue/doit-vue/vue-todo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0170c4cc"]])

export default __exports__